export const getLookupMethodsConfig = () => ({
    success: {
        WITH_USER_ID: {
            SOCIAL_ACCOUNT: {
                getNotification: (_params: { signInMethods: string[] }) => {
                    const method = _params.signInMethods[0];
                    const message = method.includes('google')
                        ? 'Use Google instead'
                        : 'Use that social login method instead.';
                    return {
                        extraMessage: message,
                    };
                },
            },
            SOFT_ACCOUNT: {
                // notification: {
                //     extraMessage:
                //         '<strong>Create an account instead</strong>. Or you can also',
                //     ctaMessage: 'Create account.',
                //     ctaAction: () => {
                //         alert('Account creation flow');
                //     },
                // },
            },
        },
        WITHOUT_USER_ID: {
            notification: {
                ctaMessage: 'Create account.',
                ctaAction: () => {
                    alert('Account creation flow');
                },
            },
        },
    },
    error: () => {
        // NOT_EMAIL_ASSOCIATED: {
        //     notification: {
        //         ctaMessage: 'Sign up',
        //         ctaAction: () => {
        //             redirectToSignUp();
        //         },
        //     },
        // },
        // DEFAULT_ERROR: () => {},
    },
});
